var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: {
      "has-header": "",
      "has-footer": "",
      "footer-buttons-on-right": "",
      open: _vm.isModalOpen,
    },
    on: { close: _vm.closeClick },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "emd-text",
              { attrs: { size: "section", "data-testid": "modal-header" } },
              [_vm._v(" " + _vm._s(_vm.$t("modalheader")) + " ")]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { attrs: { "data-testid": "modal-content" } }, [
              _vm._v(" " + _vm._s(_vm.$t("description-begin")) + " "),
              _c("b", [_vm._v(_vm._s(_vm.$t("description-highlight")))]),
              _vm._v(" " + _vm._s(_vm.$t("description-end")) + " "),
            ]),
            _c("password-confirmation", {
              staticClass: "eu-mt_5",
              attrs: {
                label: "",
                name: "input-password",
                "data-testid": "input-password",
              },
              model: {
                value: _vm.password,
                callback: function ($$v) {
                  _vm.password = $$v
                },
                expression: "password",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "emd-button",
              {
                attrs: {
                  type: "text",
                  color: "primary",
                  "data-testid": "close-modal",
                },
                on: { click: _vm.closeClick },
              },
              [_vm._v(" " + _vm._s(_vm.$t("general.exit")) + " ")]
            ),
            _c(
              "emd-button",
              {
                attrs: {
                  color: "primary",
                  "data-testid": "confirm-action",
                  disabled: _vm.disabledAction,
                },
                on: { click: _vm.confirmClick },
              },
              [_vm._v(" " + _vm._s(_vm.$t("cancelLink")) + " ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }